import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { ModalMessagerService } from '../modal-messager/modal-messager.service';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
    selector: 'app-invalid-browser',
    templateUrl: './invalid-browser.component.html',
    styleUrls: ['./invalid-browser.component.scss']
})
export class InvalidBrowserComponent implements OnInit {

    @ViewChild('switchButton', { static: true }) switchButton: ElementRef;
    @ViewChild('clipboardBtn', { static: true }) clipboardBtn: ElementRef;
    constructor(private modalMessager: ModalMessagerService, private router: Router, private activatedRoute: ActivatedRoute) {

    }

    ngOnInit() {
        this.switchButton.nativeElement.addEventListener('click', () => {
            const url = 'microsoft-edge:' + document.location.href;
            window.open(url, '_new');
        });
        this.clipboardBtn.nativeElement.addEventListener('click', () => {
            this.copyStringToClipboard(document.location.href);
            this.modalMessager.Notify('The URL has been copied', false)
        });


    }
    copyStringToClipboard(str) {
        // Create new element
        const el = document.createElement('textarea');
        // Set value (string to be copied)
        el.value = str;
        // Set non-editable to avoid focus and move outside of view
        el.setAttribute('readonly', '');
        el.style.position = 'absolute';
        el.style.left = '-9999px';
        document.body.appendChild(el);
        // Select text inside element
        el.select();
        // Copy text to clipboard
        document.execCommand('copy');
        // Remove temporary element
        document.body.removeChild(el);
    }

}
